import { SmartApplyPartner } from '@percent/cause-dashboard/constants/smartApplyPartners'

export const SMART_APPLY_PARTNER_LOGOS: Record<SmartApplyPartner, string> = {
  adobe: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeAcrobat.png'),
  adobeExpress: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeExpress.png'),
  claude: require('@percent/cause-dashboard/common/assets/images/partner-offers/Claude.png'),
  hootsuite: require('@percent/cause-dashboard/common/assets/images/partner-offers/Hootsuite.png'),
  lovable: require('@percent/cause-dashboard/common/assets/images/partner-offers/Lovable.png'),
  meta: require('@percent/cause-dashboard/common/assets/images/partner-offers/meta.png'),
  openai: require('@percent/cause-dashboard/common/assets/images/partner-offers/Openai.png'),
  zoom: require('@percent/cause-dashboard/common/assets/images/partner-offers/Zoom.webp')
}

/** Logos for sub-products shown inside the compound Adobe card. */
export const ADOBE_SUB_PRODUCT_LOGOS = {
  adobeAcrobat: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeAcrobat.png'),
  adobeExpress: require('@percent/cause-dashboard/common/assets/images/partner-offers/AdobeExpress.png')
} as const
